/* eslint-disable */
import { Response } from '@/utils/helpers/response'
import {
  Remote,
  remoteEnum
} from '@/data/remote/remoteOpen'
import Repository from '@/data/repository'

class ApiUseCase {
  get(path: string, params: string = ''): Promise<Response> {
    return new Repository(new Remote(remoteEnum.get, `${path}${params}`), null).getResult(false)
  }

  postOrPut(path: any, id: any, data: any = null, param: any = ''): Promise<Response> {
    if (id) {
      return new Repository(new Remote(remoteEnum.put, `${path}/${id}${param}`, data), null).getResult(false)
    } return new Repository(new Remote(remoteEnum.post, `${path}`, data), null).getResult(false)
  }

  patch(path: any, id: any, data: any): Promise<Response> {
    return new Repository(new Remote(remoteEnum.patch, `${path}/${id}`, data), null).getResult(false)
  }

  delete(path: any, id: any, param: any = ''): Promise<Response> {
    return new Repository(new Remote(remoteEnum.delete, `${path}/${id}${param}`), null).getResult(false)
  }

  getUser(path: any, data: any): Promise<Response> {
    return new Repository(new Remote(remoteEnum.post, `${path}`, data), null).getResult(false)
  }

  put(path: string, data: any): Promise<Response> {
    return new Repository(new Remote(remoteEnum.put, `${path}`, data), null).getResult(false)
  }

  putWithNoId(path: any, data: any): Promise<Response> {
    return new Repository(new Remote(remoteEnum.put, `${path}`, data), null).getResult(false)
  }

  postWithNoId(path: any, data: any = null): Promise<Response> {
    return new Repository(new Remote(remoteEnum.post, `${path}`, data), null).getResult(false)
  }

  patchWithNoId(path: any, data: any): Promise<Response> {
    return new Repository(new Remote(remoteEnum.patch, `${path}`, data), null).getResult(false)
  }

  getBlob(path: any): Promise<Response> {
    return new Repository(new Remote(remoteEnum.getBlob, `${path}`), null).getResult(false)
  }
}

const apiOpenUseCase = new ApiUseCase()

export default apiOpenUseCase
